import * as Phaser from "phaser-ce"
import { FontType } from "../../common/TextUtils"
import { PhaserText } from "../utils/PhaserText"
import { Scale } from "../utils/Scale"
import { Sprites } from "../utils/Sprites"
import { GenericAssets } from "./GenericAssets"

export interface BubbleBasicProps {
    text: string
    x: number
    y: number
    group: Phaser.Group
    type?: FontType
    right?: boolean
    width?: number
}

export interface BubbleTimedProps {
    texts: string[]
    stepTimes: number[]
    timer: Phaser.Timer
    x: number
    y: number
    group: Phaser.Group
    width?: number
    right?: boolean
}

export class SpeechBubble {
    static create(game: Phaser.Game, props: BubbleBasicProps) {
        return new SpeechBubbleBasic(game, props)
    }

    static createTimed(game: Phaser.Game, props: BubbleTimedProps) {
        return new SpeechBubbleTimed(game, props)
    }
}

class SpeechBubbleBasic {
    constructor(game: Phaser.Game, props: BubbleBasicProps) {
        const {text, x, y, type = FontType.BODY, group, width = 0.4, right} = props
        const padX = Scale.x(0.01)
        const padY = Scale.y(0.01)
        const bubble = Sprites.add(game, GenericAssets.SPEECH_BUBBLE, {x: x - padX, y: y - padY, group, debug: true})

        const phaserText = PhaserText.create(game, text, {x, y, fontPx: 18, wordWrapWidth: width, type, group})
        bubble.width = Scale.x(width) + padX * 2
        bubble.height = phaserText.height * 1.3 + padY * 2
        if (right) {
            Scale.flipX(bubble)
        }
    }

}

class SpeechBubbleTimed {
    constructor(game: Phaser.Game, props: BubbleTimedProps) {
        const {texts, stepTimes, group, timer, x, y, width = 0.4, right} = props
        const padX = Scale.x(0.015)
        const padY = Scale.y(0.01)
        const bubble = Sprites.add(game, GenericAssets.SPEECH_BUBBLE, {x: x - padX, y: y - padY, group, debug: true})
        bubble.alpha = 0

        // build total height of speech bubble after all text has been rendered
        let totalHeight = 0
        const builtTexts = texts.map((text) => {
            const phaserText = PhaserText.create(game, text, {x, y: y + totalHeight + padY, fontPx: 18, wordWrapWidth: width, group})
            totalHeight += phaserText.height
            phaserText.alpha = 0
            return phaserText
        })
        bubble.width = Scale.x(width) + padX * 2
        bubble.height = totalHeight * 1.3 + padY * 2
        if (right) {
            Scale.flipX(bubble)
        }

        // add bubble at the first step
        timer.add(stepTimes[0] * 1000, () => {
            bubble.alpha = 1
        })
        // add timers to each step
        stepTimes.forEach((time, idx) => {
            timer.add(time * 1000, () => {
                builtTexts[idx].alpha = 1
            })
        })
    }
}